import { gradients } from '../../../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Grid, TextField, Button, Typography, Divider, Alert, Snackbar, } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { toProperCase } from '../../../utils/formatRows';

const TransportMaster = ({ mode, id, onPopupCancel, connectionString, companyId: propsCompanyId }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = `${connectionString}/api`;
    // const { id } = useParams();
    const navigate = useNavigate();

    const [transporterName, setTransporterName] = useState('');
    const [gstNo, setGstNo] = useState('');
    const [gstError, setGstError] = useState('');
    const [formError, setFormError] = useState('');

    const username = user?.emailId;
    const companyId = (() => {
        if (mode === 'comp' || mode === 'edit') {
            return propsCompanyId ?? null;
        }
        return selectedCompany?.CompId ?? null;
    })();

    const AppRegID = selectedCompany?.AppRegID || null;

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };


    console.log(companyId);

    const fYear = selectedCompany?.financialYear;
    const userId = user?.UserId || null;
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Load existing data if editing
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios.get(`${path}/transport/getDetails/${id}`)
                .then(res => {
                    setTransporterName(res.data.TransporterName || '');
                    setGstNo(res.data.GSTNO || '');
                })
                .catch(err => console.error('Error fetching transporter:', err));
        }
    }, [id, mode]);

    // Validate GST Format
    const validateGST = (gst) => {
        const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        return gst && !regex.test(gst) ? 'Invalid GST No' : '';
    };

    const handleGSTBlur = () => { setGstError(validateGST(gstNo)); };

    const handleReset = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/transportDetail');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const gstValidation = validateGST(gstNo);
        setGstError(gstValidation);

        if (gstValidation || !transporterName) {
            setFormError('Please fill required fields correctly.');
            return;
        }

        const basePayload = {
            TransporterName: transporterName,
            GSTNO: gstNo,
            companyId,
            AppRegID,
            fYear,
            branchId: selectedCompany?.BranchId || null
        };

        let payload;

        if (mode === 'add' || mode === 'comp') {
            payload = {
                ...basePayload,
                addUserId: user?.UserId || null   // ✅ REQUIRED FOR INSERT
            };
        } else {
            payload = {
                ...basePayload,
                editUserId: user?.UserId || null  // ✅ REQUIRED FOR UPDATE
            };
        }


        try {
            if (mode === 'add' || mode === 'comp') {
                await axios.post(`${path}/transport/Insert`, payload);
                setTransporterName('');
                setGstNo('');
                setSnackbar({ open: true, message: 'Transporter added successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600)
                }
            } else if (mode === 'edit') {
                await axios.put(`${path}/transport/Update/${id}`, payload);
                setSnackbar({ open: true, message: 'Transporter updated successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600)
                }
            }


        } catch (err) {
            console.error('Error saving transporter:', err);
            setFormError('Something went wrong while saving. Please try again.');
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                handleSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleReset();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    return (
        <>
            <Box sx={{ height: 4, background: gradients.primaryRow }} />
            <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                    {mode === 'add' || mode === 'comp' ? 'Add Transporter' : 'Edit Transporter'}
                </Typography>
            </Box>
            <Divider />
            <form onSubmit={handleSubmit} noValidate>
                <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
                    <Grid container spacing={2} justifyContent={"center"}>
                        <Grid item xs={12}>
                            <TextField label="Transporter Name" value={toProperCase(transporterName)} onChange={(e) => setTransporterName(toProperCase(e.target.value))} fullWidth required size="small" InputLabelProps={{ sx: requiredAsteriskStyle }}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="GST Number" value={gstNo} onChange={(e) => setGstNo(e.target.value)} onBlur={handleGSTBlur} fullWidth size="small" error={!!gstError} helperText={gstError} />
                        </Grid>
                        {formError && (
                            <Grid item xs={12}>
                                <Alert severity="error">{formError}</Alert>
                            </Grid>
                        )}
                    </Grid>
                </Box>
                <Divider sx={{ mt: 1.5 }} />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button type="button" variant="outlined" color="inherit" size="small" onClick={handleReset}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" size="small">
                        {mode === 'add' || mode === 'comp' ? 'Save' : 'Update'}
                    </Button>
                </Box>
            </form>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default TransportMaster;